import { Bar, BarChart, CartesianGrid, LabelList, XAxis } from 'recharts';

import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';
import {
  ChartConfig,
  ChartContainer,
  ChartTooltip,
  ChartTooltipContent,
} from '@/components/ui/chart';
import { cn } from '@/lib/utils';

interface BarChartProps<D> {
  title: string;
  description?: string;
  xAxis: keyof D;
  yAxis: keyof D;
  data: Array<D>;
  chartConfig: ChartConfig;
  className?: string;
}

const Component = <D,>({
  title,
  description,
  xAxis,
  yAxis,
  data,
  chartConfig,
  className,
}: BarChartProps<D>) => (
  <Card className={cn(className)}>
    <CardHeader>
      <CardTitle>{title}</CardTitle>
      {description && <CardDescription>{description}</CardDescription>}
    </CardHeader>
    <CardContent>
      <ChartContainer
        config={chartConfig}
        className='min-h-[200px]'>
        <BarChart
          accessibilityLayer
          data={data}
          margin={{
            top: 20,
          }}>
          <CartesianGrid vertical={false} />
          <XAxis
            dataKey={xAxis as string}
            tickLine={false}
            tickMargin={10}
            axisLine={false}
            tick={{
              fill: 'var(--muted-foreground)',
            }}
          />
          <ChartTooltip
            cursor={false}
            content={<ChartTooltipContent hideLabel />}
          />

          <Bar
            dataKey={yAxis as string}
            fill='var(--primary)'
            radius={8}>
            <LabelList
              position='top'
              offset={12}
              className='fill-foreground'
              fontSize={12}
            />
          </Bar>
        </BarChart>
      </ChartContainer>
    </CardContent>
  </Card>
);

export { Component as BarChart };
